module.exports = __webpack_public_path__ + "static/media/waterpark5.0f262060.JPG";